import { useState } from "react";

import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

import PropTypes from "prop-types";

const DeleteCNAMModal = ({ onDelete, onClose, showCnam }) => {
  const [isSaveLoading, setIsSaveLoading] = useState(false);

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      show={Boolean(showCnam)}
      onHide={() => {
        setIsSaveLoading(false);
        onClose();
      }}
      contentClassName="tw-max-w-[440px]"
    >
      <Modal.Header className="tw-relative tw-mb-32px" title="Delete Caller ID Name" closeButton />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-20px tw-p-8px tw-mb-32px tw-text-14d">
        <span>
          If you delete your Caller ID Name, your <b>City and State</b> will be used in it’s place. Please
          allow up to 72 hours for the change to be applied across all carriers.
        </span>
        <span>Are you sure you want to delete the Caller ID Name?</span>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-items-center">
        <Button size="medium" schema="tertiary" onClick={onClose}>
          Close
        </Button>
        <Button
          size="medium"
          onClick={async () => {
            setIsSaveLoading(true);
            await onDelete();
            setIsSaveLoading(false);
            onClose();
          }}
          schema="warning"
          isLoading={isSaveLoading}
        >
          YES, DELETE
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCNAMModal;

DeleteCNAMModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  showCnam: PropTypes.shape({
    id: PropTypes.number,
    userId: PropTypes.number,
    displayName: PropTypes.string,
  }),
};

DeleteCNAMModal.defaultProps = {
  showCnam: null,
};
